if (!customElements.get('newsletter-popup')) {
    customElements.define('newsletter-popup', class NewsletterPopup extends ModalDialog {
        constructor() {
            super();
            this.checkAutoShow();
        }

        checkAutoShow() {
            const autoShow = this.dataset.autoShow === 'true';
            const delay = parseInt(this.dataset.delaySeconds) || 5;
            const delayAfterFirst = parseInt(this.dataset.delaySecondsAfterFirst) || 20;
            if (autoShow && !window.Shopify.designMode) {
                let currentDelay = !this.getCookie('email_popup_shown') ? delay : delayAfterFirst;
                setTimeout(() => {
                    this.show();
                    this.setCookie('email_popup_shown', 'true', 365); // Show once per day
                }, currentDelay * 1000);
            }
        }

        // Cookie helpers
        setCookie(name, value, days) {
            const expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
            document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
        }

        getCookie(name) {
            const nameEQ = name + "=";
            const ca = document.cookie.split(';');
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }
    });
}
